import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = { options: Object }

  connect() {
    this.chart = new ApexCharts(this.element, this.optionsValue)
    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
  }

  update(series) {
    this.chart?.updateSeries(series)
  }
}
